export default {
  SET_HISTORIES(state, histories) {
    state.histories = histories;
  },
};
